import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { buildQueryString } from "utils/queryStrings";
import { searchFormSelector, ISearchForm } from "redux/searchForm";
import { deepCloneObject } from "@thekilroygroup/shared-ui";

const useSetQueryParams: any = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchForm = useSelector(searchFormSelector);
  const clonedSearchForm: ISearchForm = deepCloneObject(searchForm);

  useEffect(() => {
    const currentParams: string = `${searchParams}`;
    const nextParams = buildQueryString(clonedSearchForm);
    if (currentParams !== nextParams) {
      setSearchParams(`?${nextParams}`);
    }
  }, [searchForm]);
};

export default useSetQueryParams;
